<template lang="pug">
#visualizar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtituloVisualizar")',
        :voltarPara='true',
        :exibeBotao='false'
    )

    section.visualizar-contrato-originacao__body
        .visualizar-contrato-originacao__card
            h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
            CardEmpresaVisualizarContratoAlvorada(
                v-if='isAlvorada',
                :payload='payload'
            )
            card(v-else)
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.numeroContrato }}
                    .col-2.data-display(v-if='isUsuarioLDC && payload.dadosContratoOriginacao.subTradingNome')
                        span.data-title Trading
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.subTradingNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.materialNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.safraNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.volumeContratado }}

                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.dataContrato || '--' }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.departamento') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.localidadeNivelUmNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.fornecedorParceiroNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.rucFornecedor') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.subEmpresaCnpj }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.estado') }}
                        span.data-value
                            | {{ getStatusTraduzido(this.payload.dadosContratoOriginacao.statusEmpresaCodigo) }}
                            
            section.visualizar-contrato-originacao__territorio_resumo(
                v-if='mostrarDadosVolumeTerritorio()'
            )
                h2.mt-4.mb-4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumePorTerritorio') }}
                    section.d-flex.mb-4
                        .visualizar-contrato-originacao__card__territorios
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMaximoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMaximoTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios.mr-4.ml-4
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMedioPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMedioTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios(
                            style='padding-right: 13px'
                        )
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMinimoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMinimoTerritorio }} (t)

                    section
                        .visualizar-contrato-originacao__resumo-total.d-flex
                            section(style='width: 50%')
                                .div.table-header.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeContratado') }}
                                    span {{ payload.resumo.volumeContratado }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeConforme') }}
                                    span {{ payload.resumo.volumeConforme }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeAlerta') }}
                                    span {{ payload.resumo.volumeComAlertas }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeEntregue') }}
                                    span {{ payload.resumo.volumeEntregue }}

                            section(style='width: 50%')
                                .div.table-header
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritorios') }}
                                    span {{ payload.resumo.territoriosInseridos }}
                                .div.table-column.table-column-active
                                    div
                                        i.mr-2.mt-2.flow.flow-verified.verde.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosConforme') }}
                                    span {{ payload.resumo.territoriosConforme }}
                                .div.table-column
                                    div
                                        i.mr-2.mt-2.flow.flow-warning-sign.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosAlerta') }}
                                    span {{ payload.resumo.territoriosComAlertas }}
                                .div.table-column.table-column-active
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import Card from '@/components/Card';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import TabelaSolicitacaoAnaliseCAR from '@/components/contratosOriginacao/EmpresaTabelaSolicitacaoAnaliseCar';
import { mapGetters } from 'vuex';
import CardEmpresaVisualizarContratoAlvorada from './CardEmpresaVisualizarContratoAlvorada.vue';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: {
        Card,
        CardEmpresaVisualizarContratoAlvorada,
        BaseHeader,
        TabelaSolicitacaoAnaliseCAR
    },
    data: () => ({
        payload: {
            dadosContratoOriginacao: {
                numeroContrato: null,
                fornecedorParceiroNome: null,
                culturaNome: null,
                safraNome: null,
                volumeContratado: null,
                fornecedor: null,
                statusEmpresaCodigo: null,
                subTradingId: null,
                subTradingNome: null,
                subTradingDocumento: null
            },
            volumeTerritorios: null,
            resumo: null
        },
        carregandoTabela: false
    }),
    computed: {
        ...mapGetters(['isAlvorada', 'usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado?.isLDC === true;
        }
    },
    mounted() {
        this.buscarDados();
    },
    methods: {
        async buscarDados() {
            await ContratoOriginacaoServiceEmpresa.buscarContratoOriginacaoPY(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.payload = data;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },
        mostrarDadosVolumeTerritorio() {
            return this.payload.resumo && this.payload.volumeTerritorios;
        },

        formatarData(dataISO) {
            if (!dataISO) return this.$t('mensagens.sig.erro.naoinformado');

            const data = new Date(dataISO);
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },

        getStatusTraduzido(status) {
            switch (status) {
                case 'NAO_ENVIADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoNaoEnviado'
                    );
                case 'NAO_VISUALIZADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosNaoVisualizado'
                    );
                case 'VISUALIZADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosVisualizado'
                    );
                case 'EM_CADASTRAMENTO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosEmCadastramento'
                    );
                case 'CONCLUIDO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosConcluido'
                    );
                case 'ARQUIVADO':
                    return this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosArquivado'
                    );
                default:
                    return '';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-contrato-originacao {
    .visualizar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }

    .visualizar-contrato-originacao__card {
        gap: 10px;
        display: grid;
        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }
        .button-edicao-contrato {
            display: flex;
            justify-content: flex-end;
        }
    }

    .visualizar-contrato-originacao__territorio_resumo {
        h2.mt-4.mb-4 {
            font-size: 16px;
            font-weight: bold;
        }
    }
    .visualizar-contrato-originacao__card__territorios {
        height: 80px;
        width: 100%;
        padding: 20px;
        border-radius: $default-border-radius;
        background: white;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--primary);
    }

    .d-flex.mb-4 {
        margin-top: 15px;
    }
    .visualizar-contrato-originacao__resumo-total {
        width: 100%;
        background: white;
        border-radius: $default-border-radius;
    }

    .table-header {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
        border-bottom: solid 1px #a1a1a1ff;
    }

    .table-column {
        padding: 15px 20px;
        height: 50px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }

    .table-column-active {
        background: #ecececcf;
    }

    .table-border {
        border-right: solid 1px #a1a1a1ff;
    }

    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 8px;
            color: var(--primary);
            font-weight: 600;
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }

    .mr-2.mt-2.flow.flow-warning-sign.custon-icon {
        color: var(--warning);
    }

    .visualizar-alerta {
        padding-bottom: 20px;
    }
}
</style>
